const handlePlayClick = () => {
  const video = document.querySelector('.past__video');

  const openVideo = () => {
    video.querySelector('figure').click();
  };

  document.querySelector('.past__video-button')?.addEventListener('click', () => openVideo());
};

const PastComponent = () => {
  handlePlayClick();
};

export const Past = () => {
  $(document).ready(() => PastComponent());
};
